<template>
  <div class="move-list-ce-table">
    <MoveListCeTableFilters />
    <div class="table">
      <div class="table-header flex">
        <h4 class="table-title">Fecha</h4>
        <h4 class="table-title">Hora</h4>
        <h4 class="table-title">Tag</h4>
        <h4 class="table-title">No. Económico</h4>
        <h4 class="table-title">Tipo</h4>
        <h4 class="table-title">Aforo Manual</h4>
        <h4 class="table-title">Importe</h4>
        <h4 class="table-title">Saldo Anterior</h4>
        <h4 class="table-title">Saldo Posterior</h4>
      </div>
      <MoveListCeTableRow
        v-for="crossing in crossings"
        :key="crossing.id"
        :crossing="crossing"
      />
    </div>
  </div>
</template>

<script>
import MoveListCeTableRow from '@/components/MoveListCeTableRow'
import MoveListCeTableFilters from '@/components/MoveListCeTableFilters'

export default {
  name: 'MoveListCeTable',
  components: {
    MoveListCeTableRow,
    MoveListCeTableFilters
  },
  props: {
    crossings: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/constants";

.table-header {
  background-color: $white;
  border-radius: 20px;
  margin: 2rem 0;
}

.table-title {
  text-align: center;
  margin: 0.75rem 0;
  min-width: 6rem;
  width: calc(100% / 9);
}

.table {
  overflow-x: scroll;
}

@media (max-width: 60rem) {
  .table-header {
    background-color: $light-grey;
  }

  h4 {
    font-size: 0.75rem;
  }
}
</style>
